import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import { CCard, CCardBody } from "@coreui/react";
import DateRangeDropdown from "./DateRangeDropdown";

// (b) Number of success policies vs failed/cancelled policies.
// Success = Active / Expired / Upcoming Renewals; Failed/Cancelled =
// Pending / Pending Policy (paid but never issued).
const PolicyOutcomeCard = ({ outcomeData, dateRange, setDateRange }) => {
  const chartRef = useRef(null);

  const success = (outcomeData && outcomeData.success) || 0;
  const failed = (outcomeData && outcomeData.failed) || 0;
  const byStatus = (outcomeData && outcomeData.byStatus) || [];

  useEffect(() => {
    if (!chartRef.current) {
      return;
    }
    const chart = echarts.init(chartRef.current);
    const formatNumber = (num) => num.toLocaleString();

    const option = {
      tooltip: {
        trigger: "item",
      },
      grid: {
        bottom: "5%",
      },
      legend: {
        bottom: "0%",
        left: "center",
        align: "auto",
        selectedMode: "multiple",
      },
      series: [
        {
          name: "Policies",
          type: "pie",
          radius: ["40%", "70%"],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: "center",
          },
          labelLine: {
            show: false,
          },
          data: [
            {
              value: success,
              name: "Success",
              itemStyle: { color: "#16A34A" },
            },
            {
              value: failed,
              name: "Failed / Cancelled",
              itemStyle: { color: "#DC2626" },
            },
          ],
        },
      ],
      graphic: {
        type: "group",
        left: "center",
        top: "center",
        children: [
          {
            type: "text",
            top: 0,
            style: {
              text: `${formatNumber(success + failed)}`,
              textAlign: "center",
              fill: "#252B36F2",
              fontSize: 20,
              fontWeight: "bolder",
            },
          },
          {
            type: "text",
            top: 30,
            style: {
              text: "Total",
              textAlign: "center",
              fill: "#252B36F2",
              fontSize: 14,
              fontWeight: "normal",
            },
          },
        ],
      },
    };

    chart.setOption(option);

    return () => {
      chart.dispose();
    };
  }, [outcomeData]);

  return (
    <CCard className="border-light">
      <CCardBody style={{ overflowX: "auto" }}>
        <span>Success vs Failed/Cancelled Policies</span>
        <DateRangeDropdown dateRange={dateRange} setDateRange={setDateRange} />
        <div
          ref={chartRef}
          style={{ height: "360px", width: "100%", margin: "5px auto" }}
        ></div>
        <div
          style={{
            textAlign: "center",
            marginTop: "10px",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          {byStatus.map((row, index) => (
            <div
              key={index}
              style={{ display: "inline-block", margin: "0 10px" }}
            >
              <span style={{ fontSize: "13px", color: "#555E67" }}>
                {row.status}: <strong>{row.total.toLocaleString()}</strong>
              </span>
            </div>
          ))}
        </div>
      </CCardBody>
    </CCard>
  );
};

export default PolicyOutcomeCard;
